/*!
* @Author: leo
* @Date: 2019-12-24 16:44:00
 * @Last Modified by: Robin
 * @Last Modified time: 2024-07-23 09:41:17
* @Instruduction: 总入口
*/

import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/element-ui'
import '@/permission'
import '@/plugins/vue-lazy'
import '@/utils'
import * as filters from '@/filters'
import '@/styles/index.scss'
import '@/icons/iconfont.css'

// 全局注册 JSON 展示组件 vue-json-viewer
import JsonViewer from 'vue-json-viewer'
import 'vue-json-viewer/style.css'
Vue.use(JsonViewer)

// 初始化错误日志上报
if (process.env.NODE_ENV === 'production') {
    // Sentry.init({
    //     dsn: 'https://3732c9cb6dfb4a0ba1095543d5401483@sentry.media.beer/8',
    //     release: 'dev@0.1.3',
    //     integrations: [new Integrations.Vue({ Vue, attachProps: true })]
    // })
}

// 全局注册过滤器 filter
Object.keys(filters).forEach(key => {
    Vue.filter(key, (filters as { [key: string ]: Function })[key])
})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
